// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"A3","text":"A4","date":"A5"};